<template>
  <div>
    <!-- HERO -->
    <HeroSustainability
      class="relative z-10"
      :data="page"
      @resize="onResize($event)"
    >
      <template #sidebar>
        <SustainabilitySidebar class="xl:hidden" :page="page" />
      </template>
    </HeroSustainability>

    <!-- CONTENT SIDEBAR -->
    <div ref="elContentSidebar" class="pointer-events-none">
      <div class="relative grid-cols-4 xl:grid xl:pr-container-desktop-wide">
        <div
          ref="elContentSidebarContent"
          class="col-span-3 px-container-wide sm:px-container-desktop-wide xl:pr-6"
        >
          <div class="pointer-events-auto relative my-16">
            <ComponentsLoaderSustainability :components="page.content" />
          </div>
        </div>
        <!-- DESKTOP -->
        <AnimatedContainer>
          <SustainabilitySidebar
            class="fade-in pointer-events-auto z-20 col-span-1 hidden xl:block"
            :page="page"
            :has-course-dates="page.course_dates?.length > 0"
          />
        </AnimatedContainer>
      </div>
    </div>

    <!-- CONTENT -->
    <div>
      <Container indent="wide">
        <SocialShareIcons :alternates="page.alternates" class="mb-16" />
      </Container>

      <ComponentsLoader
        v-editor-target="'sustainability_article_site_end_replicator'"
        :components="page.sustainability_article_site_end_replicator"
      />
    </div>
  </div>
</template>

<script setup>
defineProps({
  page: { type: Object, required: true },
})

provide('isSustainabilityArticle', true)

const elContentSidebar = ref(null)
const elContentSidebarContent = ref(null)

const isSidebarReady = ref(false)

// FUNCTIONS
function onResize(height) {
  isSidebarReady.value = true
  if (!elContentSidebar.value) {
    return
  }

  elContentSidebarContent.value.style.paddingTop = height + 'px'
  elContentSidebar.value.style.marginTop = -height + 'px'
}
</script>
